module.exports = __webpack_public_path__ + "static/media/selfPencil.b4f04058.jpg";